<div class="flex-grow sidenav-container min-h-full">
  <div class="sidenav" *ngIf="!isPhysician">
    <div class="sidenav-title">Menu</div>

    <div class="sidenav-item" routerLink="/home" [routerLinkActive]="['active']">
      <img src="/assets/home-icon.svg">
      Home
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" [routerLink]="['/patient', selectedFacilityId]" [class.active]="isPatientsActive">
      <img src="/assets/users.svg">
      Patients
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" routerLink="/corporation" [routerLinkActive]="['active']">
      <img src="/assets/office-building.svg">
      Corporations
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" routerLink="/facility" [routerLinkActive]="['active']">
      <img src="/assets/office-building.svg">
      Facilities
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" routerLink="/user" [routerLinkActive]="['active']">
      <img src="/assets/users.svg">
      Users
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" routerLink="/agenda" [routerLinkActive]="['active']">
      <img src="/assets/clipboard-copy.svg">
      Agenda
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" *ngIf="patient"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'forecast']"
      [routerLinkActive]="['active']">
      <img src="/assets/edit_calendar.svg">
      Forecast
      <div class="active-marker"></div>
    </div>

    <div *ngIf="hasCoSignPermission" class="sidenav-item" routerLink="/co-sign" [routerLinkActive]="['active']">
      <img src="/assets/co-sign.svg">
      Co-sign
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" *ngIf="patient"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'billing']"
      [routerLinkActive]="['active']">
      <img src="/assets/billing.svg">
      Therapy Billing
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      *ngIf="patient"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'documentation']"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/document.svg">
      Documentation
      <div class="active-marker"></div>
    </div>

    <div class="sidenav-item" routerLink="/time-card" [routerLinkActive]="['active']">
      <img src="/assets/clock.png">
      Timecard
      <div class="active-marker"></div>
    </div>
    <div class="sidenav-item" routerLink="/reports" [routerLinkActive]="['active']">
      <img src="/assets/leaderboard.svg">
      Reports
      <div class="active-marker"></div>
    </div>
    <div *ngIf="hasBiToolAccess" class="sidenav-item" [routerLink]="['/'+appRoutes.biDashboard]" [routerLinkActive]="['active']">
      <img src="/assets/dashboard-icon.svg">
      {{biDashboardConstants.title}}
      <div class="active-marker"></div>
    </div>
    <div *ngIf="hasCloseOutAccess" class="sidenav-item" routerLink="/close-out" [routerLinkActive]="['active']">
      <img src="/assets/check-circle.svg">
      Close Outs
      <div class="active-marker"></div>
    </div>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>